<template>
<b-modal title="Contratação"  size="lg" v-model="dialog" no-close-on-backdrop>
  <b-container>
    <!-- <div class="row mb-2">
      <b-form-radio class="mr-2" v-model="subscription.document_type" value="cpf"> <i class="mr-1 fas fa-user"></i>Pessoa Fisica </b-form-radio>
      <b-form-radio class="ml-2" v-model="subscription.document_type" value="cnpj"><i class="mr-1 fas fa-building"></i> Pessoa Juridica </b-form-radio>
    </div> -->
    <div class="row mb-2">
      <b-form-input v-if="subscription.document_type == 'cnpj' " v-model="subscription.name" placeholder="Razão Social"></b-form-input>
      <b-form-input v-if="subscription.document_type == 'cpf' " v-model="subscription.name" placeholder="Nome "></b-form-input>
    </div>
    <div class="row mb-2">
      <b-form-input v-if="subscription.document_type == 'cnpj' " v-mask="'##.###.###/####-##'" v-model="subscription.document_number" placeholder="cnpj"></b-form-input>
      <b-form-input v-if="subscription.document_type == 'cpf' " v-mask="'###.###.###-##'" v-model="subscription.document_number" placeholder="cpf"></b-form-input>
    </div>
    <div class="row">
      <b-form-input class="mb-2" v-mask="'(##) # ####-####'" v-model="subscription.customer_phone_number" placeholder="Telefone"></b-form-input>
      <b-form-input class="mb-2" v-model="subscription.customer_email" placeholder="Email"></b-form-input>
    </div>
    <div class="row">
      <i class="fas fa-info-circle mt-1 mr-1 " /> <span>Resumo do contrato</span>
    </div>
    <div class="row">
      <div class="col">Plano :{{plan.name}}</div>
      <div class="col">Valor :{{plan.value | decimal}}</div>
      <div class="col">Valido por {{plan.days}} dias</div>
    </div>

  </b-container>
  <div slot="modal-footer">
    <button role="button" class="btn btn-outline-secondary" @click="close()">
      <i class="fas fa-times"></i> Cancelar
    </button>
    <button role="button" class="btn btn-success" style="margin-left:5px" @click="handleStore()">
      <i class="fas fa-check"></i> Salvar
    </button>
  </div>
</b-modal>
</template>

<script>
import {
  mask
} from "vue-the-mask";

export default {

  directives: {
    mask,
  },

  data() {
    return {
      dialog: false,
      plan: {},
      subscription: {
        city: null,
        plan_id: null,
        payment_method: "boleto",
        name: null,
        document_type: "cpf", // cpf ou cnpj
        document_number: null,
        customer_phone_number: null,
        customer_email: null
      },

    }
  },

  computed: {
    company() {
      return this.$store.state.company;
    },

    documentTypeLabel() {
      return this.subscription.document_type == "cpf" ? "Cpf" : "Cnpj";
    },
    nameTypeLabel() {
      return this.subscription.document_type == "cpf" ? "Nome" : "Razão social";
    }
  },

  methods: {
    open(plan) {
      this.setPlan(plan);

      this.dialog = true;
    },

    getFormData() {

      let form = JSON.parse(JSON.stringify(this.subscription))

      form.document_number = (form.document_number) ? form.document_number.replace(/\D/g, '') : null;

      form.customer_phone_number = (form.customer_phone_number) ? form.customer_phone_number.replace(/\D/g, '') : null;

      return form
    },

    setPlan(plan) {

      if (plan.type == 'renovate') {
        this.subscription.plan_id = plan.last_plan.plan_id

        this.plan = plan.last_plan

        this.setSubscriptionDocuments()
      }

      if (plan.type == 'new_subscription') {

        this.plan = plan.plan

        this.subscription.plan_id = plan.plan.id
      }

    },
    setSubscriptionDocuments() {

      axios
        .post("api/subscribe/subscriptionDocuments")
        .then(response => {

          this.subscription = response.data.subscription_payment;

          this.subscription.name = response.data.subscription_payment.customer_name;

        })
        .catch(error => {
          this.error = error;

        });

    },

    handleStore() {

      this.$store.commit("showLoading");

      if (this.subscription.name && this.subscription.document_number && this.subscription.customer_email != null) {
        this.dialog = false;

      } else {

      }

      this.error = null;

      var url = "api/subscribe/store";

      axios
        .post(url, this.getFormData())
        .then(response => {

          this.$emit("stored");

          this.$store.commit("showAlert", {
            message: message,
            type: "success"
          });

          return;
        })
        .catch(error => {
          this.error = error;

          this.$store.commit("hideLoading");

          return;
        });

    },

    close() {
      this.dialog = false;
    },

  }

};
</script>
